import { logger } from './logger';

/**
 * Safe localStorage.setItem — silently logs on QuotaExceededError or SecurityError.
 * localStorage is cache, not primary storage (Drive is). A failure here is not fatal.
 */
export function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    logger.error('safeLocalStorage', `setItem failed for key "${key}"`, error);
  }
}

/**
 * Safe localStorage.getItem — returns null on SecurityError (restrictive environments).
 * In practice getItem rarely throws, but some browser configurations (iframe sandboxing,
 * certain enterprise policies) may deny localStorage access entirely.
 */
export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    logger.error('safeLocalStorage', `getItem failed for key "${key}"`, error);
    return null;
  }
}

/**
 * Safe localStorage.removeItem — silently logs on SecurityError (restrictive
 * environments). Same rationale as setItem: localStorage is cache, not primary
 * storage; a failure here must not break the calling flow.
 */
export function safeRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    logger.error('safeLocalStorage', `removeItem failed for key "${key}"`, error);
  }
}
